function mix(hex, withRgb, amount) {
  const raw = String(hex || '').replace('#', '');
  const full = raw.length === 3 ? raw.split('').map((c) => c + c).join('') : raw;
  if (!/^[0-9a-fA-F]{6}$/i.test(full)) return hex;
  const n = parseInt(full, 16);
  const r = (n >> 16) & 255;
  const g = (n >> 8) & 255;
  const b = n & 255;
  const nr = Math.round(r + (withRgb.r - r) * amount);
  const ng = Math.round(g + (withRgb.g - g) * amount);
  const nb = Math.round(b + (withRgb.b - b) * amount);
  return `#${[nr, ng, nb].map((v) => Math.max(0, Math.min(255, v)).toString(16).padStart(2, '0')).join('')}`;
}

export function applyPortalBrand(brand) {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  const primary = brand?.primaryColor;
  if (!primary) {
    root.style.removeProperty('--color-primary');
    root.style.removeProperty('--color-primary-hover');
    root.style.removeProperty('--color-primary-light');
    return;
  }
  root.style.setProperty('--color-primary', primary);
  root.style.setProperty('--color-primary-hover', mix(primary, { r: 0, g: 0, b: 0 }, 0.12));
  root.style.setProperty('--color-primary-light', mix(primary, { r: 255, g: 255, b: 255 }, 0.88));
}
